export type BookingType = 'family' | 'myself' | 'group'
export type Timestamp = {
    _seconds: number
    _nanoseconds: number
}

export type User = {
    id: string
    fullName: string
    email: string
    username: string
}

export type SelectedUserPackage = {
    packageId: string
    userId: string
}

export enum RecurringPackageStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    INACTIVE_PAYMENT_FAILED = 'inactive: payment failed',
    INACTIVE_PACKAGE_RENEWAL_ENDED = 'inactive: renewal cycles reached',
    INACTIVE_PACKAGE_DOES_NOT_EXIST = 'inactive: package does not exist',
    INACTIVE_PACKAGE_CANCELLED = 'inactive: user cancelled recurring package',
    INACTIVE_PACKAGE_CANCELLED_BY_STUDIO = 'inactive: Cancelled by studio',
}

export type ExpiryCriterion = 'class-date' | 'booking-date'

export type Package = {
    id: string
    name: string
    price: number
    description: string
    userId: string
    numCycles?: number
    numberPurchased: number
    classesLeft: number
    numberClasses: number
    isSubscription: boolean
    status: RecurringPackageStatus
    /**
     * The membership is valid until this date
     */
    expiresOn: Timestamp
    /**
     * Duration of the membership in days
     */
    duration: number

    // class restrictions
    hasClassRestriction: boolean
    classRestrictions: string[]

    startDate?: Timestamp
    endDate?: Timestamp

    // location restrictions
    hasLocationRestriction: boolean
    locationRestrictions: string[]

    /**
     * Whether the membership expires based on the class date
     * or booking date
     */
    expiryCriterion: ExpiryCriterion

    isGroupBookable?: boolean
    numGroupBookable?: number
}

export type Location = {
    id: string
    name: string
}

export type StudioClass = {
    id: string
    studioId: string
    name: string
    location: Location
    numCredits?: number

    startTimestamp: Timestamp
    endTimestamp: Timestamp
    isGroupBookable: boolean
    numGroupBookable: boolean
}
